
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars-near-me/collection-location/[slug]",
      function () {
        return require("private-next-pages/cars-near-me/collection-location/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars-near-me/collection-location/[slug]"])
      });
    }
  